import React from "react";
import {
    Badge
} from 'reactstrap';
//Icons
import EditIcon from 'react-icons/lib/md/edit';
import DeleteIcon from 'react-icons/lib/md/delete';
import ToolTipItem from "../utils/tooltip";
import ServerPaginatedTable from "../utils/pagination.server";

const UserWorkflowTableStructure = ({data, editCallback, pageIndex, deleteCallback}) => (
    <table className="table table-striped table-hover">
        <thead>
        <tr>
            <th>
                <span>S/N</span>
            </th>
            <th>
                <span>Name</span>
            </th>
            <th>
                <span>Email</span>
            </th>
            <th>
                <span>Action Type</span>
            </th>
            <th>
                Action
            </th>
        </tr>
        </thead>
        <tbody>
        {data.map((item, i) => <tr key={i}>
            <td className="text-capitalize">{ `${pageIndex + i + 1}`  }</td>
            <td className="text-capitalize">{`${item.FirstName} ${item.LastName}`}</td>
            <td>{`${item.Email}` }</td>
            <td className="text-capitalize">
                <Badge color='info'>&nbsp;{item.WorkflowActionName}&nbsp;</Badge>
            </td>
            <td>
                <span className="text-primary pointer" onClick={(e) => editCallback(item)}>
                   <ToolTipItem key={i + 'edit'} title={<EditIcon size="15" color="#43a8df"/>} content='Edit record' id={i + 'edit'}/>
                 </span> &nbsp;
                <span className="text-primary pointer" onClick={(e) => deleteCallback(item)}>
                   <ToolTipItem key={i + 'delete'} title={<DeleteIcon size="15" color="#ff1744"/>} content='Remove User' id={i + 'delete'}/>
                 </span>
            </td>
        </tr>)}
        </tbody>
    </table>
);

class UserWorkflowTable extends React.Component {
    render() {
        let { data, editCallback, currentPage, pageDataCallback, pageSize, totalRecordsCount, deleteCallback } = this.props;
        let pageIndex = (currentPage - 1) * pageSize;
        return (
            <ServerPaginatedTable currentPage={currentPage} fetchMore={pageDataCallback} target={<UserWorkflowTableStructure editCallback={editCallback} pageIndex={pageIndex} deleteCallback={deleteCallback} data={data}/>} pageSize={pageSize} totalCount={ totalRecordsCount }/>
        )
    }
}
export default UserWorkflowTable;



// WEBPACK FOOTER //
// ./src/views/workflow/user-table.js